import type { PlayerDto } from '@/api/dto';
import type { AvatarColor } from '@/components/ui/Avatar';
import { Avatar } from '@/components/ui/Avatar';
import { SQIcon } from '@/components/ui/SQIcon';
import { colorForPlayer } from '@/utils/colorForPlayer';
import styles from './SeatRow.module.css';

interface SeatRowProps {
  players: PlayerDto[];
  hostId: string;
  myId: string;
  myColor: AvatarColor;
  maxPlayers: number;
}

export function SeatRow({ players, hostId, myId, myColor, maxPlayers }: SeatRowProps) {
  const count = players.length;
  const ready = count >= 2;
  const ghosts = Math.max(0, maxPlayers - count);

  return (
    <>
      <div className={styles.statusLine}>
        {!ready && (
          <span className={styles.dots}>
            {[0, 1, 2].map(i => (
              <span
                key={i}
                className={styles.dot}
                style={{ animationDelay: `${i * 0.18}s` }}
              />
            ))}
          </span>
        )}
        <span className={`${styles.statusText}${ready ? ` ${styles.ready}` : ''}`}>
          {ready ? 'Можно начинать' : 'Ждём игроков'}
        </span>
      </div>

      <div className={styles.count}>
        {count} из {maxPlayers}
      </div>

      <div className={styles.seats}>
        {players.map(p => {
          const isMe = p.playerId === myId;
          const isHost = p.playerId === hostId;
          const color = isMe ? myColor : colorForPlayer(p.playerId);
          return (
            <div
              key={p.playerId}
              className={`${styles.seat}${isMe ? '' : ` ${styles.seatNew}`}`}
            >
              <div className={styles.avatarWrap}>
                <Avatar name={p.nickname} color={color} size={56} />
                {isHost && (
                  <span className={styles.crown}>
                    <SQIcon name="crown" size={16} />
                  </span>
                )}
              </div>
              <span className={styles.seatLabel}>
                {isMe ? 'Ты' : p.nickname}
              </span>
            </div>
          );
        })}

        {Array.from({ length: ghosts }).map((_, i) => (
          <div
            key={`ghost-${i}`}
            className={`${styles.seat} ${styles.ghost}`}
            style={{ animationDelay: `${i * 0.4}s` }}
          >
            <div className={styles.ghostCircle}>?</div>
            <span className={styles.ghostLabel}>ждём</span>
          </div>
        ))}
      </div>
    </>
  );
}
